import { DropdownButton, QuietButton } from "@nulogy/components";
import React from "react";

export default function Legend({ isInDropDown, closeMenu, setLegendModalOpen }) {
  return (
    <>
      {!isInDropDown && (
        <QuietButton data-testid="scheduling-guide-button" onClick={() => setLegendModalOpen(true)}>
          Legend
        </QuietButton>
      )}
      {isInDropDown && (
        <DropdownButton
          onClick={(e) => {
            setLegendModalOpen(true);
            closeMenu(e);
          }}
        >
          Legend
        </DropdownButton>
      )}
    </>
  );
}
